module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "c-text-section section o-section__contact o-section__max-w"
  }, [_c('h1', [_vm._v("Contact Us")]), _vm._v(" "), _c('div', {
    staticClass: "t-flex-grid__basic t-flex-grid__basic--contact"
  }, [_c('div', {
    staticClass: "c-details"
  }, [_c('h3', [_vm._v("CUSTOMER SERVICE")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+64-21-0870-6374"
    }
  }, [_vm._v("+64 21 0870 6374")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:sales@artfuldodgers.co.nz"
    }
  }, [_vm._v("CONTACT@ARTFULDODGERS.CO.NZ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h3', [_vm._v("WHOLESALE & RETAILERS")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "tel:+64-21-0870-6374"
    }
  }, [_vm._v("+64 21 0870 6374")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "mailto:sales@artfuldodgers.co.nz"
    }
  }, [_vm._v("SALES@ARTFULDODGERS.CO.NZ")]), _vm._v(" "), _c('a', {
    staticClass: "c-btn c-btn__link c-btn__link--back c-btn__link--contact",
    on: {
      "click": function($event) {
        _vm.$router.go(-1)
      }
    }
  }, [_vm._v("Go back")])]), _vm._v(" "), _c('div', {
    staticClass: "c-form c-form--contact",
    class: {
      'c-form--loading': _vm.formLoading
    }
  }, [_c('div', {
    staticClass: "c-spinner__container",
    class: {
      'c-spinner--visible': _vm.formLoading
    }
  }, [_c('div', {
    staticClass: "c-spinner c-spinner__sphere"
  })]), _vm._v(" "), _c('form', {
    attrs: {
      "id": "contactForm"
    },
    on: {
      "submit": function($event) {
        _vm.checkForm()
      }
    }
  }, [_c('div', {
    staticClass: "c-field c-field--first",
    class: {
      'c-field--invalid': _vm.nameError,
      'c-field--valid': _vm.nameValid,
    }
  }, [_c('label', {
    staticClass: "c-field__label",
    attrs: {
      "for": "name"
    }
  }, [_vm._v("Your name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    staticClass: "c-field__input",
    attrs: {
      "type": "text",
      "placeholder": "Robert",
      "name": "name",
      "required": ""
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.nameError),
      expression: "nameError"
    }],
    staticClass: "c-field__error"
  }, [_vm._v("Please tell us your name.")])]), _vm._v(" "), _c('div', {
    staticClass: "c-field__section"
  }, [_c('div', {
    staticClass: "c-field",
    class: {
      'c-field--invalid': _vm.contactError || _vm.emailError,
        'c-field--valid': _vm.emailValid,
    }
  }, [_c('label', {
    staticClass: "c-field__label",
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "c-field__input",
    attrs: {
      "type": "email",
      "placeholder": "RDeNiro43@gmail.com",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emailError),
      expression: "emailError"
    }],
    staticClass: "c-field__error"
  }, [_vm._v("\n              Is that a real email address? We can't verify\n              it sorry.\n            ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-field",
    class: {
      'c-field--invalid': _vm.contactError || _vm.phoneError,
        'c-field--valid': _vm.phoneValid,
    }
  }, [_c('label', {
    staticClass: "c-field__label",
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("or phone number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    staticClass: "c-field__input",
    attrs: {
      "type": "phone",
      "placeholder": "(917) 123-4567",
      "name": "phone"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emailError),
      expression: "emailError"
    }],
    staticClass: "c-field__error"
  }, [_vm._v("\n              Is that a real phone number? We can't verify it\n              sorry.\n            ")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.contactError),
      expression: "contactError"
    }],
    staticClass: "c-field__error c-field__error--section"
  }, [_vm._v("\n            We won't be able to get back to you without contact\n            details.\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "c-field c-field--textarea",
    class: {
      'c-field--invalid': _vm.messageError,
      'c-field--valid': _vm.messageError,
    }
  }, [_c('label', {
    staticClass: "c-field__label",
    attrs: {
      "for": "message"
    }
  }, [_vm._v("Message")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.message),
      expression: "message"
    }],
    staticClass: "c-field__input c-field__input--textarea",
    attrs: {
      "rows": "5",
      "placeholder": "You talkin' to me?",
      "name": "content",
      "required": ""
    },
    domProps: {
      "value": (_vm.message)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.message = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.messageError),
      expression: "messageError"
    }],
    staticClass: "c-field__error"
  }, [_vm._v("What's up?")])]), _vm._v(" "), _c('div', {
    staticClass: "c-field__section"
  }, [_c('div', {
    staticClass: "c-field c-field--checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.agreePrivacy),
      expression: "agreePrivacy"
    }],
    staticClass: "c-field__input--checkbox",
    attrs: {
      "type": "checkbox",
      "name": "AgreePrivacy",
      "id": "agreePrivacy"
    },
    domProps: {
      "checked": Array.isArray(_vm.agreePrivacy) ? _vm._i(_vm.agreePrivacy, null) > -1 : (_vm.agreePrivacy)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.agreePrivacy,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.agreePrivacy = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.agreePrivacy = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.agreePrivacy = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "c-field__label c-field__label--checkbox",
    attrs: {
      "for": "agreePrivacy"
    }
  }, [_vm._v("Accept privacy policy")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.agreePrivacyError),
      expression: "agreePrivacyError"
    }],
    staticClass: "c-field__error c-field__error--captcha"
  }, [_vm._v("Please accept our privacy policy.")])]), _vm._v(" "), _c('div', {
    staticClass: "g-recaptcha",
    attrs: {
      "data-sitekey": "6LeFa6kUAAAAAGruS5mADwIa3F417B-7UvrCVcvS",
      "data-callback": "recaptchaCallback"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "c-form__toast",
    attrs: {
      "id": "toast"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "c-form__submit c-btn--block",
    attrs: {
      "type": "submit",
      "id": "submit"
    },
    on: {
      "click": function($event) {
        _vm.checkForm($event)
      }
    }
  }, [_vm._v("Send")])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6735d208","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Contact.vue
// module id = 397
// module chunks = 0